import { render, staticRenderFns } from "./MatchSetOverview.vue?vue&type=template&id=459e8025&scoped=true&"
import script from "./MatchSetOverview.vue?vue&type=script&lang=ts&"
export * from "./MatchSetOverview.vue?vue&type=script&lang=ts&"
import style0 from "./MatchSetOverview.vue?vue&type=style&index=0&id=459e8025&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459e8025",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VSimpleTable})
